import { useCallback } from 'react';
import { useThree } from '@react-three/fiber';
import animation from './Sphere.animation.json';
import { parallax } from '@immutabl3/alchemy/three';
import SphereMaterial from './SphereMaterial';

export default function Sphere({ nodes }) {   
  const camera = useThree(({ camera }) => camera);

  const onPercChange = useCallback((_, ref) => {
    const orb = ref.current;
    if (!orb) return;

    orb.lookAt(camera.position);

    orb.visible = orb.material.opacity !== 0;
  }, [camera]);

  return (
    <parallax.mesh
      name="Sphere"
      geometry={ nodes.Sphere.geometry }
      position={ [21.49, 31.79, 6.85] }
      rotation={ [-0.31, 1.26, -0.47] }
      scale={ 1 }

      beaker="chapter3"
      animation={ animation }
      onPercChange={ onPercChange }
    >
      <SphereMaterial />
    </parallax.mesh>
  );
};